<script lang="ts">
  import SectionCarteEmittedList from '@/generated/sections/SectionCarteEmittedList.vue';
  import Transaction from '@/extend/classes/Transaction';
  import { ColumnFilter, ListChoix, ListFilter } from '@/extend/classes/ListData';
  import Section from '@/framework/base/classes/Section';
  import { TransactionTypes, TransactionStatuts } from '@/generated/classes/Transaction';
  import { defineComponent } from "vue";
  import { isProduction } from "@/framework/base/helpers/Environment";

  export default defineComponent({
    components: {},
    extends: SectionCarteEmittedList,
    props: {
      transaction: {
        type: Transaction,
      }
    },
    data() {
      return {
        lastDeliveryId: -1
      };
    },
    computed: {
      headers() {
        return [
          { text: "Date", value: 'dateTransaction', cellClass: '', sortable: true },
          { text: "Emetteur", value: 'ownerLabel', cellClass: '', sortable: true },
          { text: "Carte", value: 'paymentMeans', cellClass: '', sortable: true },
          { text: "Montant", value: 'amount', cellClass: '', sortable: true },
          { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
        ];
      },
      canAdd(): boolean {
        return false;
      },
      items(): unknown[] {
        if (this.transaction && this.transaction.deliveryId != this.lastDeliveryId) {
          this.defaultFilter();
          this.setLastRoute();
          this.loadTable();
          this.isInitialised = true;
          if (this.transaction) {
            this.lastDeliveryId = this.transaction.deliveryId;
          }
        }
        return this.listData.reccords;
      }
    },
    methods: {
      canUpdate(transaction: Transaction): boolean {
        return false;
      },
      defaultFilter(): void {
        this.filter.pageLimit = 10
        this.activeFilters = [];
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionTypes.CARTE_BANCAIRE_RECU;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "deliveryId";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = this.transaction ? this.transaction.deliveryId : 0;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
      },
      selectItem(event: any, row: any): void {
      },

      mdiAction(transaction: Transaction): string {
        return 'fas fa-landmark';
      },
      hasAction(transaction: Transaction): boolean {
        return transaction.bankId == 0;
      },
      execAction(transaction: Transaction): void {
        this.actionProgress = true;
        Transaction.rapproche(transaction).then(() => {
          this.actionProgress = false;
        }).catch(() => {
          this.actionProgress = false;
        });
      }
    }
  })

</script>
